function CLoader(cv) {
	this.node = document.getElementById(cv);
	this.ctx = this.node.getContext("2d");
	this.width = this.node.width;
	this.height = this.node.width;
	this.style = {},
	this.style.percents = false;
	this.style.color = "#ff0000";
	this.style.bgcolor = "#ffffff";
	this.style.thickness = 5;
	
	this.setFont("#ffffff", 16, "Arial", 30);
};

CLoader.prototype.progress = function(p) {
	if (!isNaN(p)) {
		
		this.ctx.clearRect ( 0 , 0 , this.width, this.height );
		this.ctx.beginPath();
		this.ctx.arc(this.width * 0.5, this.height * 0.5,this.width * 0.4 ,1.5 * Math.PI , (2 * Math.PI  * 100) - 0.5 * Math.PI);
		this.ctx.fillStyle = "rgba(0,0,0,0.6)";
		this.ctx.fill();	

		this.ctx.beginPath();
		this.ctx.arc(this.width * 0.5, this.height * 0.5,this.width * 0.4 ,1.5 * Math.PI , (2 * Math.PI  * 100) - 0.5 * Math.PI);
		this.ctx.strokeStyle = this.style.bgcolor;	
		this.ctx.lineWidth = this.style.thickness;	
		this.ctx.stroke();	

		if (p > 0) {
			this.ctx.beginPath();
			this.ctx.arc(this.width * 0.5, this.height * 0.5,this.width * 0.4 ,1.5 * Math.PI , (2 * Math.PI  * p) - 0.5 * Math.PI);
			this.ctx.strokeStyle = this.style.color;	
			this.ctx.lineWidth = this.style.thickness - 2;	
			this.ctx.stroke();	
			
			if (this.style.percents) {
				var txt = Math.round(p * 100).toString() + "%";
				var tt = this.ctx.measureText(txt);
				this.ctx.font = this.style.fontSize + "px " + this.style.fontFamily;
				this.ctx.fillStyle = this.style.fontColor;	
				this.ctx.fillText(txt, this.width * 0.5 - tt.width * 0.5, this.style.fontTop);
			}
		}
	} else {
		this.progress(0);
	}
}

CLoader.prototype.setStyle = function(color, thick) {
		this.style.color = color;
		this.style.thickness = thick;
	};
	
CLoader.prototype.setFont = function(color, size, font, top) {
		this.style.fontColor = color;
		this.style.fontSize = size;
		this.style.fontFamily = font;
		this.style.fontTop = top;
	};
	
CLoader.prototype.showPercent = function(b) {
		this.style.percents = b;
	};
